module.exports = __webpack_public_path__ + "media/images/SettingsCogDropdown-bd816e63464332129aa9c5765e9c32e7.png";